import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(
  (theme) => ({
    listItemRoot: {
      '&$selected': {
        backgroundColor: "#F0F1F2",
      },
    },
    listItemActive: {
      borderRight: `solid 5px ${theme.palette.primary.main}`,
    },
    listItemInactive: {},
    selected: {
      color: theme.palette.primary.main,
    },
    icon:{
      minWidth: '0!important',
      paddingRight: 10,
    },
    iconRoot: {
      color: theme.palette.primary.main,
    },
    nested: {
      color: '#5C6571!important',
      paddingLeft: '26px!important',
    },
    subHeaderNested:{
      paddingLeft: '26px!important',
    },
    disabledLink: {
      pointerEvents: 'none',
    },
    subMenuText: {
      fontSize: '15px!important',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
    subHeader: {
      fontSize: '15px!important',
      color: '#231F20!important',
      marginLeft : '4px!important'
    },
  }),
  // {
  //   name: 'SubMenuList',
  // },
);
